export default "__VITE_ASSET__be9ffc81__"